import { dataTransferWrap } from '../dataTransferService'
import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import dtConfig from '@/config/data-transfer'


const dtCompanyFuelSettingsConfig = dtConfig[ModulesMap.COMPANY_FUEL_SETTINGS]

function getCompanyFuelSettings(companyId, materialsSettingsId) {
	return dataTransferWrap(
		ModulesMap.COMPANY_FUEL_SETTINGS,
		dtCompanyFuelSettingsConfig[ModulesConfigMap[ModulesMap.COMPANY_FUEL_SETTINGS].GET_COMPANY_FUEL_SETTINGS],
		{
			urlParams: {
				companyId,
				materialsSettingsId,
			},
		},
	)
}

function patchCompanyFuelSettings(companyId, materialsSettingsId, body) {
	return dataTransferWrap(
		ModulesMap.COMPANY_FUEL_SETTINGS,
		dtCompanyFuelSettingsConfig[ModulesConfigMap[ModulesMap.COMPANY_FUEL_SETTINGS].PATCH_COMPANY_FUEL_SETTINGS],
		{
			urlParams: {
				companyId,
				materialsSettingsId,
			},
			...body,
		},
	)
}

export default {
	getCompanyFuelSettings,
	patchCompanyFuelSettings,
}
